/* file description */

import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
// import Field from '@ant-design/pro-field';
import { BetaSchemaForm, ProFormInstance } from '@cui/pro-components';

import styles from './index.module.less';
import { Popup, Button, Space, Toast, Modal } from 'antd-mobile';
import { SPForm, FormFrom } from '@/components/SPForm';

export const ListFilter = forwardRef(({
  mergeColumns,
  search = true,
  setParams,
  editableSearchParams,
  floadSearch = false,
}: any, ref) => {
  // const formSingleRef = useRef<ProFormInstance>();
  const filterFormRef = useRef<ProFormInstance>();
  const [showFilter, setShowFilter] = useState(false);

  const searchColumns = (mergeColumns || []).filter(
    (item: any) => item.search !== false,
  );

  useImperativeHandle(ref, () => ({
    setShowFilter,
  }));


  if (searchColumns.length === 0 || !search) {
    return null;
  }
  // const anchors = [100, window.innerHeight * 0.4, window.innerHeight * 0.6];
  if (floadSearch) {
    return (
      <div className={styles.floatingBox}>
        <Button
          block
          color="primary"
          onClick={async () => {
            const result = await Modal.confirm({
              closeOnMaskClick: true,
              style: { zIndex: 2000 },
              cancelText: '重置',
              confirmText: '搜索',
              content: (
                <div className={styles['modal-form']}>
                  <SPForm
                    ref={filterFormRef}
                    defaultValue={editableSearchParams}
                    from={FormFrom.Search}
                    columns={searchColumns}
                    submitter={false}
                  />
                </div>
              ),
            });
            if (result) {
              const values = filterFormRef.current?.getFieldsValue();
              setParams(values);
              setShowFilter(false);
            } else {
              filterFormRef.current?.resetFields();
              setParams({});
              setShowFilter(false);
            }
          }}
        >点击展开搜索
        </Button>
        {/* <Collapse
          activeKey={collapseSearch}
          onChange={(activeKey) => {
            setCollapseSearch(activeKey);
          }}
        >
          <Collapse.Panel key="1" title="点击展开搜索">
            <div>
              <SPForm
                ref={filterFormRef}
                defaultValue={editableSearchParams}
                from={FormFrom.Search}
                columns={searchColumns}
                submitter={false}
              />
              <div className={styles['filter-form-bottom']}>
                <Button
                  onClick={() => {
                    filterFormRef.current?.resetFields();
                    setParams({});
                    setShowFilter(false);
                    setCollapseSearch([-1]);
                  }}
                >
                  重置
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    const values = filterFormRef.current?.getFieldsValue();
                    setParams(values);
                    setShowFilter(false);
                    setCollapseSearch([-1]);
                  }}
                >
                  查询
                </Button>
              </div>
            </div>
          </Collapse.Panel>
        </Collapse> */}
      </div>
    );
  }

  return (
    <div className={styles['filter-wrap']}>
      {/* <img
          width={100}
          src={optionImages}
          onClick={() => {
            setShowFilter(true);
          }}
        /> */}
      <Popup
        visible={showFilter}
        onMaskClick={() => {
          setShowFilter(false);
        }}
      >
        <div
          style={{
            height: '40vh',
            overflowY: 'scroll',
            padding: '20px 10px 0px 10px',
          }}
        >
          <SPForm
            ref={filterFormRef}
            defaultValue={editableSearchParams}
            from={FormFrom.Search}
            columns={searchColumns}
            submitter={false}
          />
        </div>
        <div className={styles['filter-form-bottom']}>
          <Button
            style={{ width: '40%' }}
            onClick={() => {
              filterFormRef.current?.resetFields();
              setParams({});
              setShowFilter(false);
            }}
          >
            重置
          </Button>
          <Button
            color="primary"
            style={{ width: '40%' }}
            onClick={() => {
              const values = filterFormRef.current?.getFieldsValue();
              setParams(values);
              setShowFilter(false);
            }}
          >
            确定
          </Button>
        </div>
      </Popup>
    </div>
  );
});
